const moduleNameSourceFilesMap = {
  ace: [
    'https://cdnjs.cloudflare.com/ajax/libs/ace/1.36.5/ace.min.js'
  ]
};

export default moduleNameSourceFilesMap;